/** The documents lab's page: a spinner while its chunk loads (labRoute.ts). */

import type { FunctionComponent } from "preact";
import { useEffect, useState } from "preact/hooks";
import { ignore } from "../lib/ignore.ts";
import { Spinner } from "../ui/Spinner.tsx";
import { labChunk } from "./labRoute.ts";

export function LabPage() {
  const [lab, setLab] = useState<FunctionComponent | null>(null);
  useEffect(() => {
    labChunk.load().then((page) => setLab(() => page), ignore);
  }, []);
  const Lab = lab;
  return Lab ? <Lab /> : <Spinner />;
}
